<template>
  <div
    :class="[
      'border rounded-lg p-4 h-full max-h-screen flex flex-col transition-all',
      isFocused ? 'ring-2 ring-indigo-500' : ''
    ]"
    ref="container"
  >
    <h4 class="font-semibold mb-2 shrink-0">Teams</h4>

    <ul class="overflow-y-auto flex-1 min-h-0">
      <li
        v-for="team in sortedTeams"
        :key="team.id"
        :ref="`team-${team.id}`"
        @click="$emit('select', team.id)"
        :class="[
          'cursor-pointer p-1 flex items-center justify-between',
          selected === team.id ? 'bg-indigo-100' : ''
        ]"
      >
        <span>{{ team.name }}</span>
        <span class="text-xs text-gray-500 ml-2">{{ getMemberCount(team.id) }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TeamList',
  
  props: {
    teams: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Number,
      default: null
    },
    isFocused: {
      type: Boolean,
      default: false
    },
    sessionUsers: {
      type: Array,
      default: () => []
    }
  },
  
  emits: ["select"],

  computed: {
    sortedTeams() {
      return [...(this.teams || [])].sort((a, b) =>
        (a.name || "").localeCompare(b.name || "", "en", { sensitivity: "base" })
      );
    }
  },

  methods: {
    getMemberCount(teamId) {
      if (!this.sessionUsers || this.sessionUsers.length === 0) {
        return 0;
      }
      
      return this.sessionUsers.filter(user => {
        return user.team_ids && user.team_ids.includes(teamId);
      }).length;
    },
    
    scrollToSelected() {
      this.$nextTick(() => {
        const ref = this.$refs[`team-${this.selected}`];
        const container = this.$refs.container?.querySelector("ul");
        if (ref && ref[0] && container) {
          const itemTop = ref[0].offsetTop;
          const itemBottom = itemTop + ref[0].offsetHeight;
          const containerTop = container.scrollTop;
          const containerBottom = containerTop + container.clientHeight;

          if (itemTop < containerTop) {
            container.scrollTop = itemTop - 10;
          } else if (itemBottom > containerBottom) {
            container.scrollTop = itemBottom - container.clientHeight + 10;
          }
        }
      });
    }
  }
};
</script>
